import { RemindersView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

/**
 * Settings · AI Brain › Appointment Reminders (amendment 25 §2) — **a summary**.
 *
 * Every *Edit* leaves this page for the section's own editor. The old page kept
 * the messages inside modals on this one, which is why they had no preview and no
 * test.
 */
export function SettingsRemindersPage() {
  const navigate = useNavigate();
  return (
    <RemindersView
      onEditSection={(key) => {
        void navigate(`/settings/ai/reminders/${sectionPath(key)}/messages`);
      }}
      onOpenAppointmentReasons={() => {
        void navigate('/settings/appointment-reasons');
      }}
      onOpenPracticeManagement={() => {
        void navigate('/settings/general');
      }}
    />
  );
}

/**
 * `before` · `missed` · `review` sit at the top level; a procedure lives under
 * `after/`, because there is one editor per procedure and they need a namespace.
 */
function sectionPath(key: string): string {
  return key === 'before' || key === 'missed' || key === 'review' ? key : `after/${key}`;
}
